<template>
  <div class="p-4 hover:bg-gray-50 border-b last:border-b-0 cursor-pointer" @click="viewProfile">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <div class="text-3xl mr-3">{{ profile.avatar || '👤' }}</div>
        <div>
          <h4 class="font-medium">{{ profile.name }}</h4>
          <p class="text-sm text-gray-500">{{ profile.age }} • Last call: {{ profile.lastCall }}</p>
          <div class="flex items-center mt-1">
            <div class="w-16 bg-gray-200 rounded-full h-2 mr-2">
              <div 
                :class="['h-2 rounded-full', getWellnessColor(profile.wellness)]"
                :style="`width: ${profile.wellness}%`"
              ></div>
            </div>
            <span class="text-xs text-gray-500">{{ profile.wellness }}%</span>
          </div>
        </div>
      </div>
      
      <div class="flex items-center space-x-2">
        <span :class="['badge badge-sm', getStatusBadgeClass(profile.status)]">
          {{ profile.status }}
        </span>
        <button @click.stop="quickCall" class="btn btn-primary btn-sm">
          <PhoneIcon class="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { PhoneIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  profile: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['call', 'view'])

function getWellnessColor(score) {
  if (score >= 80) return 'bg-success-500'
  if (score >= 60) return 'bg-warning-500'
  return 'bg-danger-500'
}

function getStatusBadgeClass(status) {
  const classes = {
    'Good': 'badge-success',
    'Fair': 'badge-warning',
    'Excellent': 'badge-success',
    'Poor': 'badge-danger'
  }
  return classes[status] || 'badge-secondary'
}

function viewProfile() {
  emit('view', props.profile)
}

function quickCall() {
  emit('call', props.profile)
}
</script>